import { useQuery } from "@tanstack/react-query"
import { gorgiasTicketActivityQuery } from "../lib/gorgiasTicketActivityQuery"

export function useGorgiasTicketActivityQuery(
  ...args: Parameters<typeof gorgiasTicketActivityQuery>
) {
  return useQuery(gorgiasTicketActivityQuery(...args))
}
